import type { FactionId } from '@archon3d/core';
import type { SessionSnapshot } from './session';

/** A side by the board's name for it. */
export function boardSideName(ctx: SessionSnapshot['ctx'], id: FactionId): string {
  return ctx.board.def.factions.find((f) => f.id === id)?.name ?? id;
}

/** A side as people read it: the board's name for it, after the name of the person playing it. */
export function sideName(snapshot: Pick<SessionSnapshot, 'ctx' | 'names'>, id: FactionId): string {
  const side = boardSideName(snapshot.ctx, id);
  const person = snapshot.names[id];
  return person ? `${person} (${side})` : side;
}
